import { createPortal } from "react-dom";
import { ReactComponent as CloseIcon } from "../assets/icons/icon-close.svg";
import styles from "../../../styles/aprt.module.scss";

const Modal = ({ open, onClose, children }) => {
  if (!open) return null;

  return createPortal(
    <div className={styles.modal_overlay}>
      <div className={styles.modal_content}>
        <button title="close" className={styles.modal_close} onClick={onClose}>
          <CloseIcon />
        </button>
        {children}
      </div>
    </div>,
    document.body
  );
};

export default Modal;
